import { useEffect } from "react";
import ReactDOM from "react-dom";
import classes from "./ExamToast.module.scss";

const ExamToast = ({ message, onClose, durationMs = 3200 }) => {
    useEffect(() => {
        const timer = setTimeout(() => onClose?.(), durationMs);
        return () => clearTimeout(timer);
    }, [onClose, durationMs]);

    return ReactDOM.createPortal(
        <div className={classes.toast} role="status" aria-live="polite">
            <p className={classes.toastMessage}>{message}</p>
        </div>,
        document.body
    );
};

export default ExamToast;
